export const UPDATE_FLOW_SIGNAL = 'UPDATE_FLOW_SIGNAL'
export const RUN_FLOW_SIGNAL = 'RUN_FLOW_SIGNAL'
export const PUB_FLOW_SIGNAL = 'PUB_FLOW_SIGNAL'
